import {Moment} from 'moment';

const formatDateTimeHuman = (momentDate: Moment, now?: Moment) => {
  return momentDate.calendar(now, {
    sameDay: '[Today] h:mma',
    nextDay: '[Tomorrow] h:mma',
    nextWeek: 'dddd h:mma',
    lastDay: '[Yesterday] h:mma',
    lastWeek: 'M/D/YY h:mma',
    sameElse: 'M/D/YY h:mma',
  });
};

export default formatDateTimeHuman;
